// #ifdef APP-PLUS
import appAuth from './app-auth.js'
// #endif
import { AppType } from '../constant.js'
import permissionEnums from './permissionEnums.js'

// 微信小程序权限校验
const wxCheck = (permit, option) => {
  const permitStr = `scope.${permit}`
  wx.getSetting({
    success (res) {
      if (!res.authSetting[permitStr]) {
        wx.authorize({
          scope: permitStr,
          success: () => {
            option.success && option.success()
          },
          fail: () => {
            handleAuthFail(permit, option, () => {
              wx.openSetting({
                success: setRes => {
                  if (setRes.authSetting[permitStr]) {
                    option.success && option.success()
                  } else {
                    option.fail && option.fail()
                    uni.showToast({
                      title: '授权失败',
                      icon: 'none',
                      duration: 2000
                    })
                  }
                }
              })
            }, option.fail)
          }
        })
      } else {
        option.success && option.success()
      }
    }
  })
}

// 处理未授权
const handleAuthFail = (permit, option, callBack, errCallBack) => {
  uni.showModal({
    title: option.title || '温馨提示',
    content: option.content || `开启${permissionEnums[permit].name}权限后，才能${permissionEnums[permit].explain}`,
    confirmText: '去开启',
    success: (mdlRes) => {
      if (mdlRes.confirm) {
        uni.setStorageSync('cloudGoOpenAuth', 1) // 用于app授权后返回页面时重新操作流程
        callBack()
      } else if (mdlRes.cancel) {
        uni.showToast({
          title: '取消授权',
          icon: 'none',
          duration: 2000
        })
        errCallBack && errCallBack()
      }
    }
  })
}

// APP权限校验
const appCheck = async (permit, option) => {
  // 详见constant文件AppType
  const appType = +uni.getStorageSync('cloudAppType')
  // 5.安卓 6.苹果
  let authRes = false
  if (appType === AppType.ANDROID) {
    const res = await appAuth.requestAndroidPermission(`android.permission.${permit}`)
    authRes = res === 1
  } else if (appType === AppType.IOS) {
    authRes = appAuth.judgeIosPermission(permit)
  }
  if (authRes) {
    option.success && option.success()
    return
  }
  handleAuthFail(permit, option, () => {
    // 打开App权限设置界面
    appAuth.gotoAppPermissionSetting()
  }, option.fail)
}

const handleAuthKey = (key) => {
  // 详见constant文件AppType
  const appType = +uni.getStorageSync('cloudAppType')
  // 1:小程序 5:安卓 6:ios
  switch (key) {
    // 定位
    case 'location':
      if (appType === AppType.MINI) {
        return 'userLocation'
      } else if (appType === AppType.ANDROID) {
        return 'ACCESS_FINE_LOCATION'
      } else if (appType === AppType.IOS) {
        return 'location'
      }
      break
      // 外部存储(含相册)读取权限
    case 'readStorage':
      if (appType === AppType.MINI) {
        return null
      } else if (appType === AppType.ANDROID) {
        return 'READ_EXTERNAL_STORAGE'
      } else if (appType === AppType.IOS) {
        return 'photoLibrary'
      }
      break
      // 外部存储(含相册)写入权限
    case 'writeStorage':
      if (appType === AppType.MINI) {
        return 'writePhotosAlbum'
      } else if (appType === AppType.ANDROID) {
        return 'WRITE_EXTERNAL_STORAGE'
      } else if (appType === AppType.IOS) {
        return 'photoLibrary'
      }
      break
    case 'camera': // 摄像头权限
      if (appType === AppType.MINI) {
        return null
      } else if (appType === AppType.ANDROID) {
        return 'CAMERA'
      } else if (appType === AppType.IOS) {
        return 'camera'
      }
      break
    default:
      return ''
  }
}

// 权限校验
export function checkAuthorize (permit, option = {}) {
  // #ifdef APP-PLUS
  handleAuthKey(permit) ? appCheck(handleAuthKey(permit), option) : option.success?.()
  // #endif
  // #ifdef MP-WEIXIN
  handleAuthKey(permit) ? wxCheck(handleAuthKey(permit), option) : option.success?.()
  // #endif
  // #ifndef MP-WEIXIN || APP-PLUS
  option.success?.()
  // #endif
}
